import { useTranslation } from "react-i18next";
import { Activity, Building2, Flag, Search, Users } from "lucide-react";
import { NeuCard, NeuInput } from "../../components/neu/Neu";

const PRIORITIES = ["low", "medium", "high", "urgent"];
const STATUSES = ["new", "in_progress", "pending_review", "completed", "rejected", "cancelled", "overdue"];

const Sel = ({ icon: Icon, label, tone, testid, value, onChange, children }) => (
  <label className="grid gap-1.5">
    <span className={`flex items-center gap-1.5 text-xs font-black ${tone}`}><Icon className="h-4 w-4" /> {label}</span>
    <div className="relative flex items-center rounded-2xl bg-background shadow-neu-sm focus-within:ring-2 focus-within:ring-ring">
      <select data-testid={testid} value={value} onChange={onChange}
        className="neu-select h-12 w-full appearance-none rounded-2xl bg-transparent ps-4 text-sm font-bold text-foreground focus:outline-none">
        {children}
      </select>
    </div>
  </label>
);

export const TaskFilters = ({ filters, setFilters, employees, branches, canManage }) => {
  const { t } = useTranslation();
  const set = (key) => (e) => setFilters({ ...filters, [key]: e.target.value });
  const all = t("tasks.filters.all");
  return (
    <NeuCard className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-3 lg:grid-cols-5" data-testid="task-filters">
      <label className="col-span-2 grid gap-1.5 sm:col-span-3 lg:col-span-1">
        <span className="flex items-center gap-1.5 text-xs font-black text-primary"><Search className="h-4 w-4" /> {t("tasks.filters.search")}</span>
        <NeuInput data-testid="task-filter-search" value={filters.q} onChange={set("q")} placeholder={t("tasks.filters.search")} />
      </label>
      {canManage ? (
        <Sel icon={Users} label={t("tasks.filters.employee")} tone="text-sky-600" testid="task-filter-employee"
             value={filters.assignee_id} onChange={set("assignee_id")}>
          <option value="">{all}</option>
          {employees.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
        </Sel>
      ) : null}
      {canManage ? (
        <Sel icon={Building2} label={t("tasks.filters.branch")} tone="text-emerald-600" testid="task-filter-branch"
             value={filters.branch_id} onChange={set("branch_id")}>
          <option value="">{all}</option>
          {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </Sel>
      ) : null}
      <Sel icon={Flag} label={t("tasks.filters.priority")} tone="text-amber-600" testid="task-filter-priority"
           value={filters.priority} onChange={set("priority")}>
        <option value="">{all}</option>
        {PRIORITIES.map((p) => <option key={p} value={p}>{t(`tasks.priority.${p}`)}</option>)}
      </Sel>
      <Sel icon={Activity} label={t("tasks.filters.status")} tone="text-violet-600" testid="task-filter-status"
           value={filters.status} onChange={set("status")}>
        <option value="">{all}</option>
        {STATUSES.map((s) => <option key={s} value={s}>{t(`tasks.status.${s}`)}</option>)}
      </Sel>
    </NeuCard>
  );
};
